/* 创建者 程楠 推荐商品列表页面 */
<template>
  <div id="goods-list-page">
    <div
      class="breadcrumb wrapper"
      style="line-height: 30px"
    >
      <span>
        <router-link to="/">首页</router-link>
      </span>
      <span class="arrow">&gt;</span>
      <span>推荐商品</span>
    </div>
    <div class="container wrapper clearfix">
      <div
        v-if="$route.query.type == 4"
        style="float: left; height: 100%; width: 200px;background-color: #fff;padding: 8px;box-sizing: border-box;"
      >
        <!-- 左侧类型选择 -->
        <div style="font-size: 14px;text-align: center;background-color: rgb(236, 103, 26);color: #fff;line-height: 30px;border-radius: 8px;">商品类型选择</div>
        <el-scrollbar style="height: 600px;">
          <div
            class="coupon-type-box"
            :class="couponActiveIndex == index ? 'coupon-active' : ''"
            @click="selectType(item, index)"
            v-for="(item, index) in couponTypeList"
            :key="index"
          >
            {{ item.name }}
          </div>
        </el-scrollbar>
      </div>

      <!-- 右侧商品 -->
      <div
        class="right"
        id="result"
      >
        <div
          class="shop_con_list"
          id="main-nav-holder"
        >
          <p
            v-if="this.list.length == 0 && !this.loading"
            style="
              color: red;
              font-size: 20px;
              text-align: center;
              margin-top: 20px;
            "
          >
            抱歉,暂无推荐商品!
          </p>
          <right-goods
            :data="list"
            v-if="type != 10"
          ></right-goods>
          <exchange-goods
            :data="list"
            v-else
          ></exchange-goods>
          <div
            v-show="total > 0 && couponActiveIndex !== 0"
            class="page-wrapper"
          >
            <Page
              :total="total"
              :current="page"
              :page-size="pageSize"
              show-elevator
              show-total
              @on-change="changePage"
            >
            </Page>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Scrollbar } from "element-ui";
import { getCatList } from "api/home";
import { couponActive } from "api/goods";
import rightGoods from "./module-recommend-goods.vue";
import exchangeGoods from "./exchange-goods.vue";
import {
  recommendGoods,
  zyGoods,
  getMidAds,
  getCategory,
  gettExchangeAds,
  activeGoods,
  getNonDirect,
} from "api/home";

export default {
  components: {
    rightGoods,
    exchangeGoods,
    [Scrollbar.name]: Scrollbar,
  },
  data() {
    return {
      aggs: "",
      list: [],
      keywords: "",
      vouchers_status: 0,
      search_type: 0,
      goods_local: false,
      order: "desc",
      page: 1,
      pageSize: 12,
      loading: false,
      query: {},
      total: 0,
      source_flag: "",
      type: "",
      couponTypeList: [
        {
          name: "精选",
          catId: "jx",
        },
        {
          name: "全部",
          catId: "all",
        },
      ],
      couponActiveIndex: 0,
    };
  },
  created() {
    this.fetchData();
    this.type = this.$route.query.type;
  },
  methods: {
    getCatList() {
      getCatList({ categoryParentId: 0 }).then((res) => {
        this.couponTypeList = this.couponTypeList.concat(res.data);
      });
    },

    // 现金券专区全部商品
    couponActive(catId) {
      let data = {};
      if (catId) {
        data = {
          pageNo: this.page,
          pageSize: this.pageSize,
          catId: catId,
        };
      } else {
        data = {
          pageNo: this.page,
          pageSize: this.pageSize,
        };
      }

      couponActive(data).then((res) => {
        if (res.resCode === 1) {
          this.list = res.data.list;
          this.total = res.data.total;
        }
      });
    },

    // 选择现金券商品类型
    selectType(item, index) {
      this.couponActiveIndex = index;
      this.page = 1;
      if (item.catId == "all") {
        this.couponActive();
      } else if (item.catId == "jx") {
        let params = {};
        params.actityType = 4;
        params.rowNum = 50;
        activeGoods(params).then((json) => {
          if (json.resCode === 1) {
            this.loading = false;
            json.data.map((l) => {
              l.thumbnail = l.imgUrl;
              l.name = l.title;
              return l;
            });
            this.list = json.data;
          } else {
            console.log("获取推荐商品列表数据错误！");
          }
        });
      } else {
        this.couponActive(item.catId);
      }
    },

    changePage(index) {
      this.page = index;
      this.fetchData();
    },
    fetchData() {
      if (!this.loading) {
        // this.total = 0;
        this.loading = true;
        let query = this.$route.query;

        let params = {
          ...this.query,
          pageNo: this.page,
          pageSize: this.pageSize,
        };

        /**type类型不同，取不同的专区接口
         * 1. 推荐专区
         * 2. 直营优品专区
         * 3. 新人首单免费专区
         * 4. 现金券积分抵扣专区
         * 5. 消费全返专区
         * 6. 每日上新
         * 7. 热销榜
         * 8. 自营积分购物专区
         * 9. 爆款专区
         */
        switch (query.type) {
          case "1": {
            //  默认推荐页
            recommendGoods(params).then((json) => {
              if (json.resCode === 1) {
                this.loading = false;
                let data = json.data;
                this.list = data.list;
                this.total = data.total;
              } else {
                console.log("获取推荐商品列表数据错误！");
              }
            });
            break;
          }
          case "2": {
            //  直营优品专区
            zyGoods(params).then((json) => {
              if (json.resCode === 1) {
                this.loading = false;
                const { storeSlideShowTag, storeTagsGoods } = json.data;

                let list = [];
                // if (storeSlideShowTag) {
                //   list = list.concat(storeSlideShowTag.map(item => {
                //     item.thumbnail = item.imgUrl;
                //     item.name = item.tip;
                //   }))
                // }
                if (storeTagsGoods) {
                  let goodsList = [];
                  storeTagsGoods.forEach((s) => {
                    const { list: goods } = s;
                    goodsList = goodsList.concat(goods);
                  });

                  list = list.concat(
                    goodsList.map((item) => {
                      item.thumbnail = item.imgUrl;
                      item.name = item.tip;
                      return item;
                    })
                  );
                }

                this.list = list;
              } else {
                console.log("获取推荐商品列表数据错误！");
              }
            });
            break;
          }
          case "3": {
            //首单免费专区
            params.sourceFlag = 6;
            getMidAds(params).then((json) => {
              if (json.resCode === 1) {
                this.loading = false;
                // console.log(json);

                // const { list: { list, total } = {} } = json.data;
                this.list = json.data.classificationGoodsDTOPager.list;
                this.total = json.data.classificationGoodsDTOPager.total;
              } else {
                console.log("获取推荐商品列表数据错误！");
              }
            });
            break;
          }
          case "4": {
            this.getCatList();
            //现金券积分抵扣专区
            params.actityType = 4;
            params.rowNum = 50;
            activeGoods(params).then((json) => {
              if (json.resCode === 1) {
                this.loading = false;
                json.data.map((l) => {
                  l.thumbnail = l.imgUrl;
                  l.name = l.title;
                  return l;
                });
                this.list = json.data;
              } else {
                console.log("获取推荐商品列表数据错误！");
              }
            });
            break;
          }
          case "5": {
            //消费全返专区
            params.sourceFlag = 7;
            getMidAds(params).then((json) => {
              if (json.resCode === 1) {
                this.loading = false;
                this.list = json.data.classificationGoodsDTOPager.list;
                this.total = json.data.classificationGoodsDTOPager.total;
              } else {
                console.log("获取推荐商品列表数据错误！");
              }
            });
            break;
          }
          case "6": {
            //每日上新
            params.actityType = 2;
            params.rowNum = 50;
            activeGoods(params).then((json) => {
              if (json.resCode === 1) {
                this.loading = false;
                json.data.forEach((list) => {
                  list.thumbnail = list.imgUrl;
                  list.name = list.title;
                });
                this.list = json.data;
              } else {
                console.log("获取推荐商品列表数据错误！");
              }
            });
            break;
          }
          case "7": {
            //热销榜
            params.actityType = 1;
            params.rowNum = 50;
            activeGoods(params).then((json) => {
              if (json.resCode === 1) {
                this.loading = false;
                json.data.forEach((list) => {
                  list.thumbnail = list.imgUrl;
                  list.name = list.title;
                });
                this.list = json.data;
              } else {
                console.log("获取推荐商品列表数据错误！");
              }
            });
            break;
          }
          case "8": {
            //自营积分购物专区
            params.sourceFlag = 8;
            getMidAds(params).then((json) => {
              if (json.resCode === 1) {
                this.loading = false;

                this.list = json.data.classificationGoodsDTOPager.list;
                this.total = json.data.classificationGoodsDTOPager.total;
              } else {
                console.log("获取推荐商品列表数据错误！");
              }
            });
            break;
          }
          case "9": {
            //爆款专区
            params.activeType = 10;
            getCategory(params).then((json) => {
              if (json.resCode === 1) {
                this.loading = false;
                const { pager: { list, total } = {} } = json.data;
                this.list = list;
                this.total = total;
              } else {
                console.log("获取推荐商品列表数据错误！");
              }
            });
            break;
          }
          case "10": {
            //免费换购专区
            gettExchangeAds(params).then((json) => {
              if (json.resCode === 1) {
                this.loading = false;
                const data = json.data;
                this.list = data.list;
                this.total = data.total;
              } else {
                console.log("获取推荐商品列表数据错误！");
              }
            });
            break;
          }

          case "11": {
            //一村一品
            params.actityType = 8;
            params.rowNum = 50;
            activeGoods(params).then((json) => {
              if (json.resCode === 1) {
                this.loading = false;
                json.data.forEach((list) => {
                  list.thumbnail = list.imgUrl;
                  list.name = list.title;
                });
                this.list = json.data;
              } else {
                console.log("获取推荐商品列表数据错误！");
              }
            });
            break;
          }
          case "12": {
            //年货狂欢购
            params.actityType = 9;
            params.rowNum = 50;
            activeGoods(params).then((json) => {
              if (json.resCode === 1) {
                this.loading = false;
                json.data.forEach((list) => {
                  list.thumbnail = list.imgUrl;
                  list.name = list.title;
                });
                this.list = json.data;
              } else {
                console.log("获取推荐商品列表数据错误！");
              }
            });
            break;
          }
          case "13": {
            //限时特价
            params.actityType = 3;
            params.rowNum = 50;
            activeGoods(params).then((json) => {
              if (json.resCode === 1) {
                this.loading = false;
                json.data.forEach((list) => {
                  list.thumbnail = list.imgUrl;
                  list.name = list.title;
                });
                this.list = json.data;
              } else {
                console.log("获取推荐商品列表数据错误！");
              }
            });
            break;
          }
          case "14": {
            //非自营专区
            params.searchType = 1;
            getNonDirect(params).then((json) => {
              if (json.resCode === 1) {
                this.loading = false;
                this.list = json.data.data;
                this.total = json.data.totalCount;
              } else {
                console.log("获取推荐商品列表数据错误！");
              }
            });
            break;
          }
          default: {
            return;
          }
        }
      }
    },
  },
  // 销毁组件，返回刷新
  deactivated() {
    this.$destroy();
  },
};
</script>
<style scoped>
#goods-list-page .wrapper {
  width: 1200px !important;
  margin: 0 auto;
}

.page-wrapper {
  margin: 20px 0;
  text-align: right;
}
.coupon-type-box {
  width: 80%;
  margin-left: 10%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  color: #333;
  font-size: 16px;
  line-height: 28px;
}
.coupon-type-box:hover {
  color: rgb(236, 103, 26);
}
.coupon-active {
  color: rgb(236, 103, 26);
}
</style>



// WEBPACK FOOTER //
// recommend-goods.vue?734b628f